import { render } from "./ValueBox.vue?vue&type=template&id=d552d1b6&scoped=true&ts=true"
import script from "./ValueBox.vue?vue&type=script&lang=ts"
export * from "./ValueBox.vue?vue&type=script&lang=ts"

import "./ValueBox.vue?vue&type=style&index=0&id=d552d1b6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d552d1b6"]])

export default __exports__